import Decision from "../Components/Decision";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Events from "./Events";
// import OurStory from "./OurStory";
import { useState } from "react";

export default function Home() {
    return (
      <div>
        <Header />
        {/* <OurStory /> */}
        <Events />
        <Decision/>
        <Footer />
      </div>
    );
  }